/** Grupo lógico de um formulário de cadastro: subtítulo sobre a régua, campos
 *  embaixo. É a hierarquia visual dos cadastros grandes (Samuel, 01/09/2026) —
 *  o formulário em tela cheia ganhava 30 campos corridos e a pessoa se perdia.
 *  Fonte única: o formulário de contrato e os configs de gestão usam o mesmo. */
import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

export function FormSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Divider textAlign="left">
        <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 1 }}>{title}</Typography>
      </Divider>
      {children}
    </Box>
  )
}
